<mat-card class="billing-card">
    <mat-card-content>
        <form [formGroup]="billingForm">
            <mat-form-field class="w-100" appearance="outline">
                <mat-label i18n="@@numberOfSponsors">Number of sponsors</mat-label>
                <input formControlName="sponsorCounts" matInput disabled id="sponsorCounts" name="sponsorCounts"/>
            </mat-form-field>
            <mat-form-field class="w-100" appearance="outline">
                <mat-label i18n="@@total">Total</mat-label>
                <input formControlName="totalFees" matInput disabled id="totalFees" name="totalFees"/>
            </mat-form-field>
            <mat-form-field class="w-100" appearance="outline">
                <mat-label i18n="@@totalAfterDiscount">Total after discount</mat-label>
                <input formControlName="totalFeesDiscount" matInput disabled id="totalFeesDiscount" name="totalFeesDiscount"/>
            </mat-form-field>
        </form>
        <div i18n="@@InvalidAppliedPromotionsMessage" class="mat-subtitle-1 text-center" matTooltip ellipsisTooltip>
            Order Review Page - Invalid applied promotions will not result into a discount.
        </div>
        <div class="d-flex mt-30">
            <div data-testid="paypal_button" class="w-100" id="paypal-checkout-btn"></div>
            <button i18n="@@buyWithCard" data-testid="paypal_button" class="w-100 mr-16 buy-with-card-button" mat-raised-button color="accent" (click)="buyWithCard()">Buy with card</button>
            <!-- <button *ngIf="false" i18n="@@buyWithPayPal" data-testid="paypal_button" class="w-100" mat-raised-button color="accent" (click)="buyWithPayPal()">Buy with PayPal</button> -->
        </div>
    </mat-card-content>
</mat-card>
